__turbopack_context__.v({
  "byline": "PageHeader-module__aAyEQW__byline",
  "future": "PageHeader-module__aAyEQW__future",
  "header": "PageHeader-module__aAyEQW__header",
  "headerContent": "PageHeader-module__aAyEQW__headerContent",
  "heading": "PageHeader-module__aAyEQW__heading",
  "intro": "PageHeader-module__aAyEQW__intro",
  "mainAction": "PageHeader-module__aAyEQW__mainAction",
  "unpublished": "PageHeader-module__aAyEQW__unpublished",
  "wrapper": "PageHeader-module__aAyEQW__wrapper",
});
